/*                                                                                                                
,------.                                    ,--.          ,--.      ,--------.    ,------.            ,--.           
|  .-.  \,--. ,--.,--,--,  ,--,--.,--,--,--.`--' ,---.    |  | ,---.'--.  .--'    |  .-.  \  ,--,--.,-'  '-. ,--,--. 
|  |  \  :\  '  / |      \' ,-.  ||        |,--.| .--'    |  || .-. |  |  |       |  |  \  :' ,-.  |'-.  .-'' ,-.  | 
|  '--'  / \   '  |  ||  |\ '-'  ||  |  |  ||  |\ `--.    |  |' '-' '  |  |       |  '--'  /\ '-'  |  |  |  \ '-'  | 
`-------'.-'  /   `--''--' `--`--'`--`--`--'`--' `---'    `--' `---'   `--'       `-------'  `--`--'  `--'   `--`--'
*/

import { GeofenceDrawManager } from '../../map/draw';
import { VisionApplication } from '../../application';
import { VisionWindow } from '../../window/window';
import { VisionRockingTab } from './rocking';
import { RockingSegmentDTO, VisionRockingService } from './rocking.service';
import { Measurement } from '../../components/measurement';

class MapController {
    controlDiv: HTMLDivElement;

    constructor(owner: VisionEditRockSegmentWindow) {
        this.controlDiv = document.createElement('div');
        const controlButton = document.createElement('button');
        controlButton.className = 'btn';
        controlButton.innerHTML = '<i class="fa fa-search"></i> Toggle Labels';
        this.controlDiv.appendChild(controlButton);

        controlButton.addEventListener('click', () => {
            owner.toggleLabels();
        });
    }
}

export class VisionEditRockSegmentWindow extends VisionWindow {
    private layout!: dhtmlXLayoutObject;
    private segments!: dhtmlXGridObject;
    private toolbar!: dhtmlXToolbarObject;
    private form!: dhtmlXForm;

    private segmentCache!: Map<string, RockingSegmentDTO>;
    private parent: VisionRockingTab;
    private service: VisionRockingService;

    private map!: google.maps.Map;

    private drawingManager!: GeofenceDrawManager;

    geofences!: Map<string, google.maps.Polygon>;
    markers!: Map<string, google.maps.marker.AdvancedMarkerElement>;

    constructor(parent: VisionRockingTab) {
        const width = window.innerWidth * 0.85;

        super(VisionApplication.getInstance().windowManager, {
            id: 'rock_segment_window',
            title: 'Edit Rocking Segment',
            x: 30,
            y: 30,
            width: width,
            height: 600,
        });
        this.parent = parent;
        this.window.setText('Manage Rocking Segments');
        this.modal = false;
        this.segmentCache = new Map<string, RockingSegmentDTO>();
        this.service = this.parent.service;

        this.geofences = new Map<string, google.maps.Polygon>();
        this.markers = new Map<string, google.maps.marker.AdvancedMarkerElement>();

        this.buildLayout();
    }

    private async buildLayout() {
        this.layout = this.window.attachLayout('3W');
        this.layout.cells('a').hideArrow();
        this.layout.cells('b').hideArrow();

        const width = window.innerWidth * 0.85;
        this.layout.cells('a').setWidth(0.25 * width);
        this.layout.cells('b').setWidth(0.25 * width);
        this.layout.cells('c').setWidth(0.5 * width);

        // Device Grid
        this.layout.cells('a').setText('Rocking Segments');
        this.segments = this.layout.cells('a').attachGrid();
        this.segments.setImagesPath('css/imgs/');
        this.segments.setHeader('Name,Required Tons,Show', '', ['text-align:center;', 'text-align:center', 'text-align:center']);
        this.segments.attachHeader(['#text_filter', '', '#master_checkbox'], ['text-align:center;', 'text-align:center', 'text-align:center']);
        this.segments.setColAlign('left,center,center');

        this.segments.setColTypes('ro,ro,ch');
        this.segments.setColSorting('str,int,int');
        this.segments.init();

        // Device Properties
        this.layout.cells('b').setText('Properties');
        this.toolbar = this.layout.cells('b').attachToolbar();
        this.toolbar.addButton('new', 0, 'New', 'icons/sign.png', '');
        this.toolbar.addButton('save', 1, 'Save', 'css/imgs/save.gif', '');
        this.toolbar.addSeparator('sep1', 2);
        this.toolbar.addButton('delete', 3, 'Delete', 'icons/clear.png', '');

        this.layout.cells('c').setText('Map');
        this.map = this.layout.cells('c').attachMap({
            center: { lat: 41.96593, lng: -91.67687 },
            zoom: 8,
            mapId: 'dad62ca70e7e3c4b6f8cbf8c',
        });

        this.drawingManager = new GeofenceDrawManager(this.map, undefined);

        const form_data = [
            { type: 'settings', position: 'label-left', labelWidth: 90, inputWidth: 130 },
            { name: 'id', type: 'input', label: 'ID', value: '', inputWidth: '250', offsetLeft: '25', offsetTop: '25', disabled: true },
            { name: 'name', type: 'input', label: 'Name', value: '', inputWidth: '250', offsetLeft: '25', required: false },
            { name: 'colour', type: 'colorpicker', label: 'Color', value: '', inputWidth: '250', offsetLeft: '25', required: true, enableCustomColors: '1' },
            { name: 'description', type: 'input', label: 'Description', value: '', rows: '3', inputWidth: '250', offsetLeft: '25' },
            { name: 'required', type: 'input', label: 'Required Rock', value: '', inputWidth: '250', offsetLeft: '25' },
        ];
        this.form = this.layout.cells('b').attachForm({});
        this.form.loadStruct(form_data);
        this.form.lock();

        this.layout.cells('a').hideHeader();
        this.layout.cells('b').hideHeader();
        this.layout.cells('c').hideHeader();

        this.setupEvents();
        this.getSegments();

        const controller = new MapController(this);
        this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(controller.controlDiv);
    }

    private getSegments(): void {
        this.segments.clearAll(false);
        const request = this.service.cachedFetchData();
        request.then((data) => {
            data.forEach((segment) => {
                this.addSegment(segment);
            });
        });
    }

    private setupEvents(): void {
        /** Fired when tool bar items are clicked
         * TODO: Move to common function
         */
        this.toolbar.attachEvent('onClick', (itemId) => {
            if (itemId == 'new') {
                if (this.drawingManager.geofence) this.drawingManager.geofence.setMap(null);
                this.drawingManager.setMode('polygon');
                this.clearForm();
                this.segments.clearSelection();
                this.form.unlock();
            }

            if (itemId == 'save') {
                this.saveGeofence();
            } else if (itemId == 'delete') {
                this.deleteSegment();
            }
        });

        this.segments.attachEvent('onRowSelect', (rowid, colInd) => {
            this.segmentSelected(rowid, colInd);
        });

        this.segments.attachEvent('onCheckbox', (rid, _cid, state) => {
            this.toggleSegment(rid, state);
        });

        this.form.attachEvent('onChange', (name: string, value: string | number, _state: boolean) => {
            if (name == 'colour') {
                const newcolor = value as string;
                if (this.drawingManager.geofence) {
                    this.drawingManager.geofence.setOptions({ fillColor: newcolor });
                }

                const id = this.segments.getSelectedRowId();
                const style = 'color:black;border:3px solid ' + newcolor + ';';
                this.segments.setCellTextStyle(id, 0, style);
            }
        });
    }

    private toggleSegment(rid: string, state: boolean): void {
        let geo = this.geofences.get(rid);
        let marker = this.markers.get(rid);

        if (geo == undefined) {
            const segment = this.segmentCache.get(rid);
            const bounds = new google.maps.LatLngBounds();
            segment?.geometry.forEach((latlng) => {
                bounds.extend(latlng);
            });

            let name = '';
            if (segment) {
                name = segment.id.name;
            }

            const segmentName = document.createElement('div');
            segmentName.className = 'segment-tag';
            segmentName.textContent = name;

            marker = new google.maps.marker.AdvancedMarkerElement({
                position: bounds.getCenter(),
                //title: segment?.id.name
                content: segmentName,
            });
            this.markers.set(rid, marker);

            geo = new google.maps.Polygon({
                paths: segment?.geometry,
                strokeColor: segment?.colour,
                strokeOpacity: 0.8,
                fillColor: segment?.colour,
                strokeWeight: 2,
                fillOpacity: 0.85,
                editable: false,
                draggable: false,
            });
            this.geofences.set(rid, geo);
        }

        if (state == true) {
            geo.setMap(this.map);
            if (marker) {
                marker.map = this.map;
            }
        } else {
            geo.setMap(null);
            if (marker) {
                marker.map = null;
            }
        }
    }

    private segmentSelected(rowid: string, _colInd: number) {
        this.form.unlock();
        this.populateForm(this.segmentCache.get(rowid));
        this.displaySegment(this.segmentCache.get(rowid));
    }

    private clearForm(): void {
        this.form.setItemValue('id', '');
        this.form.setItemValue('name', '');
        this.form.setItemValue('description', '');
        this.form.setItemValue('required', '');
        this.form.setItemValue('colour', '');
        this.form.lock();
    }

    private populateForm(segment: RockingSegmentDTO | undefined): void {
        this.form.setItemValue('id', segment?.id.id);
        this.form.setItemValue('name', segment?.id.name);
        this.form.setItemValue('description', segment?.description);
        if (segment?.requiredKg != undefined) {
            this.form.setItemValue('required', Measurement.kg2ImperialTons(segment?.requiredKg));
        } else {
            this.form.setItemValue('required', '');
        }
        this.form.setItemValue('colour', segment?.colour);
    }

    private displaySegment(segment: RockingSegmentDTO | undefined): void {
        this.drawingManager.geofence?.setMap(null);

        this.drawingManager.geofence = new google.maps.Polygon({
            paths: segment?.geometry,
            strokeColor: segment?.colour,
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillOpacity: 0.85,
            editable: true,
            draggable: true,
            fillColor: segment?.colour,
        });
        this.drawingManager.geofence.setMap(this.map);
        this.drawingManager.setMode('select');
        this.zoomToGeofence(segment);
    }

    private zoomToGeofence(segment: RockingSegmentDTO | undefined): void {
        const bounds = new google.maps.LatLngBounds();

        segment?.geometry.forEach((item) => {
            bounds.extend(item);
        });
        this.map.fitBounds(bounds);
    }

    private verifyForm(): boolean {
        if (this.drawingManager.geofence == undefined) {
            dhtmlx.alert({
                title: 'Segment Error',
                text: 'No Geofence was found',
                type: 'alert-error',
            });
            return false;
        }

        const path = this.drawingManager.geofence.getPath().getArray();
        if (path.length < 4) {
            dhtmlx.alert({
                title: 'Segment Error',
                text: 'Geofence not large enough',
                type: 'alert-error',
            });
            return false;
        }

        const name = this.form.getItemValue('name');
        if (name == undefined || name == '') {
            dhtmlx.alert({
                title: 'Segment Error',
                text: 'Segment has no name',
                type: 'alert-error',
            });
            return false;
        }

        const required = this.form.getItemValue('required');
        if (required == undefined || required == '') {
            dhtmlx.alert({
                title: 'Segment Error',
                text: 'Segment needs to have required tonnage value.',
                type: 'alert-error',
            });
            return false;
        }

        return true;
    }

    /** Delete a rocking segment
     *
     */
    private deleteSegment(): void {
        const id = this.form.getItemValue('id');

        dhtmlx.confirm({
            type: 'confirm-warning',
            title: 'Confirm Delete',
            text: 'This will delete the segment from the platform.',
            callback: (result: boolean) => {
                if (result == true) {
                    this.service.deleteSegment(id).then((data) => {
                        if (data.parsedBody) {
                            dhtmlx.message({
                                title: 'Complete',
                                text: 'Segment was deleted',
                                type: 'alert-success',
                            });

                            this.segmentCache.delete(id);
                            this.segments.deleteRow(id);
                            this.drawingManager.geofence?.setMap(null);
                            this.drawingManager.geofence = undefined;
                            this.drawingManager.setMode('polygon');

                            this.segments.clearSelection();
                            this.clearForm();
                            this.service.cache = undefined;
                        }
                    });
                }
            },
        });
    }

    private saveGeofence(): void {
        if (this.drawingManager.geofence == undefined) {
            return;
        }

        if (this.verifyForm() == false) {
            return;
        }

        const path = this.drawingManager.geofence.getPath().getArray();
        path.push(path[0]);
        const id = this.form.getItemValue('id');
        const name = this.form.getItemValue('name');
        const description = this.form.getItemValue('description');
        const required = this.form.getItemValue('required');
        const colour = this.form.getItemValue('colour');

        const data = {} as RockingSegmentDTO;
        data.id = { id: id, name: name };
        data.geometry = path;
        data.description = description;
        data.requiredKg = Measurement.imperialTons2Kg(Number(required));
        data.colour = colour;

        const request = this.service.saveSegment(data);

        request.then((data) => {
            if (data?.ok) {
                if (data.parsedBody) {
                    this.updateSegment(data.parsedBody);

                    dhtmlx.message({
                        title: 'Segment Saved',
                        text: 'Geofence ' + data.parsedBody?.id.name + ' was saved.',
                        type: 'alert-success',
                    });

                    this.drawingManager.geofence?.setMap(null);
                    this.drawingManager.geofence = undefined;
                    this.drawingManager.setMode('polygon');
                    this.segments.clearSelection();
                    this.segments.cells(data.parsedBody.id.id, 1).setValue(Measurement.kg2ImperialTons(data.parsedBody.requiredKg).toString());

                    const geo = this.geofences.get(data.parsedBody?.id.id);
                    if (geo) {
                        geo.setPath(data.parsedBody.geometry);
                    }

                    this.clearForm();
                    this.service.cache = undefined;
                }
            }
        });
    }

    private updateSegment(segment: RockingSegmentDTO): void {
        if (this.segmentCache.has(segment.id.id)) {
            this.segments.cells(segment.id.id, 0).setValue(segment.id.name);
            this.segmentCache.set(segment.id.id, segment);
        } else {
            this.addSegment(segment);
        }
        this.form.setItemValue('id', segment.id.id);
    }

    private addSegment(segment: RockingSegmentDTO): void {
        this.segmentCache.set(segment.id.id, segment);
        this.segments.addRow(segment.id.id, [segment.id.name, Measurement.kg2ImperialTons(segment.requiredKg), 0], 0, '', '', false);

        const style = 'color:black;border:3px solid ' + segment.colour + ';';
        this.segments.setCellTextStyle(segment.id.id, 0, style);
    }

    public toggleLabels(): void {
        const segments = this.segments.getCheckedRows(2).split(',');

        segments.forEach((id: string) => {
            const marker = this.markers.get(id);
            if (marker == undefined) {
                return;
            }
            if (marker.map == undefined) {
                marker.map = this.map;
            } else {
                marker.map = undefined;
            }
        });
    }
}
